import { StorageKeys } from './../models/storage-keys';
import { LocalStorageService } from './../../core/services/local-storage.service';
import { EncryptionParams } from './../constants';
import * as crypto from 'crypto-js';
import { Injectable } from '@angular/core';

@Injectable()
export class EncryptionUtil {

	constructor(private localStorage: LocalStorageService) { }

	iv;
	salt;
	keySize = EncryptionParams.KEYSIZE / 32;
	passphrase = EncryptionParams.PASSPHRASE;
	iterationCount = EncryptionParams.ITERATIONCOUNT;

	getEncryptedPassword(password) {
		this.setEncData();
		const encryptedPassword = this.encrypt(this.salt, this.iv, this.passphrase, password);
		return encryptedPassword;
	}

	getDecryptedData(encData) {
		const decData = this.decrypt(this.salt, this.iv, this.passphrase, encData);
		return decData;
	}

	encryptData(password, salt = EncryptionParams.SALT, iv = EncryptionParams.IV) {
		const encryptedPassword = this.encrypt(salt, iv, this.passphrase, password);
		return encryptedPassword;
	}

	decryptData(encData, salt = EncryptionParams.SALT, iv = EncryptionParams.IV) {
		const decData = this.decrypt(salt, iv, this.passphrase, encData);
		return decData;
	}

	private setEncData() {
		this.iv = crypto.lib.WordArray.random(128 / 8).toString(crypto.enc.Hex);
		this.salt = crypto.lib.WordArray.random(128 / 8).toString(crypto.enc.Hex);
	}

	private encrypt(salt, iv, passPhrase, plainText) {
		const key = this.generateKey(salt, passPhrase);
		const encrypted = crypto.AES.encrypt(plainText, key, { iv: crypto.enc.Hex.parse(iv) });
		return encrypted.ciphertext.toString(crypto.enc.Base64);
	}

	private decrypt(salt, iv, passPhrase, cipherText) {
		const key = this.generateKey(salt, passPhrase);
		const cipherParams = crypto.lib.CipherParams.create({
			ciphertext: crypto.enc.Base64.parse(cipherText)
		});
		const decrypted = crypto.AES.decrypt(cipherParams, key, { iv: crypto.enc.Hex.parse(iv) });
		return decrypted.toString(crypto.enc.Utf8);
	}

	private generateKey(salt, passPhrase) {
		const key = crypto.PBKDF2(
			passPhrase,
			crypto.enc.Hex.parse(salt),
			{ keySize: this.keySize, iterations: this.iterationCount });
		return key;
	}

	getDecryptedId() {
		const encryptedId = this.localStorage.get(StorageKeys.uniqueIdentifier);
		const decryptedId = this.decryptData(encryptedId);
		return decryptedId;
	}

	generateHashedValue(message: string, key: string, iv: string): string {
    const parsedKey = crypto.enc.Latin1.parse(key);
    const parsedIV = crypto.enc.Latin1.parse(iv);
    const encryptedValue = crypto.AES.encrypt(message, parsedKey, {
      iv: parsedIV
    });
    return encryptedValue.toString();
  }
}
